import {useEffect, useRef, useState} from "react";
import $ from 'jquery';
const Slider = (
    {
        min = 0,
        max = 100,
        value = 0,
        step = 1,
        range = false,
        disabled = false,
        onChange = (item) => {},
        onStop = (item) => {},
    }
) => {
    const sliderElement = useRef();
    const [sliderValue, setSliderValue] = useState(value);

    const handleOnchange = (val) => {
        onChange(val);
    }
    const handleOnStop = (val) => {
        onStop(val);
    }

    useEffect(() => {
        $(sliderElement.current).slider({
            min,
            max,
            value,
            values: value,
            step,
            range,
            disabled,
            change: (event, ui) => {
                // setSliderValue(range ? ui.values : ui.value);
                // handleOnchange(range ? ui.values : ui.value)
            },
            create: (event, ui) => {
                // if(range){
                //     let payload = {
                //         event: event,
                //         ui: ui,
                //         values: value,
                //         isLastSlider: true,
                //         sliderObject: $(sliderElement.current),
                //         setSliderValue
                //     }
                //     handleOnchange(payload)
                //     // setSliderValue(ui.values);
                //     // console.log("Next sib " , ui.handle.nextSibling);   
                // }
            },
            slide: (event, ui) => {
                if(range){
                    let payload = {
                        event: event,
                        ui: ui,
                        values: ui.values,
                        isLastSlider: ui.handle.nextSibling == null,
                        sliderObject: $(sliderElement.current),
                        setSliderValue
                    }
                    handleOnchange(payload)
                    // setSliderValue(ui.values);
                    // console.log("Next sib " , ui.handle.nextSibling);   
                } else {
                    setSliderValue(range ? ui.values : ui.value);
                    handleOnchange(range ? ui.values : ui.value);
                }
            },
            start: (event, ui) => {

            },
            stop: (event, ui) => {
                setSliderValue(range ? ui.values : ui.value);
                // handleOnchange(range ? ui.values : ui.value);
                handleOnStop(range ? ui.values : ui.value);
            },
        })

        return () => {
            $(sliderElement.current).slider('destroy');
        }
    }, [value]);

    return (
        <div ref={sliderElement} className="slider">
            <div className="slider-bar"
                 style={{width: ((sliderValue - min) * 100) / (max - min) + '%'}}></div>
        </div>
    )
}

export default Slider;
